import china_area_code from "../../../static/json/100000_full_geo.json"
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
export default {
  data() {
    return {
      map_data: {},
      map: null, // 地图
      geo_layer: null,  // 地域块对象
      info_control: null, //地图右上角信息控件
    }
  },
  methods: {
    getDataFormat() {
      var data = JSON.parse(window.sessionStorage.getItem('esg_risk'))
      this.map_data = JSON.parse(data.insurance_area_data)
      var format_data = {}
      for(let i=0;i<this.map_data.length;i++){
        format_data[`${this.map_data[i].region}`] = this.map_data[i].esg_
      }
      this.map_data = format_data
    },
    leafletMap () {
      if( !this.map ) {
        this.map = L.map('ins_esg_map', {
          center: [35, 110],
          zoom: 3,
          zoomControl: false,
          doubleClickZoom: false,
          fillColor: '#fff',
          fill: '#fff',
        })

        this.initInfoControl()
        this.info_control.addTo(this.map)
        
      } else {
        this.map.removeLayer(this.geo_layer)
      }
      this.geo_layer = L.geoJSON(china_area_code, {
        style: this.style,
        onEachFeature: this.onEachFeature
      }).addTo(this.map)
    },
    // 地图获取颜色，在style中调用
    getColor(name) {
      let color = '#fff'
      if(this.map_data.hasOwnProperty(name)){
        switch (this.map_data[name]) {
          case 'A': 
            color = '#51d83b' 
            break;
          case 'B': 
            color = '#30b2a3' 
            break;
          case 'C': 
            color = '#f8ac2e' 
            break;
          case 'D': 
            color = '#f6775b' 
            break;
        
          default:
            break;
        }
      }
      return color;
    },
    // 地图获取样式
    style(feature) {
      return {
        fillColor: this.getColor(feature.properties.name),
        weight: 2,
        opacity: 1,
        color: '#7e7e7b',
        dashArray: '3',
        fillOpacity: 0.7
      }
    },
    // 初始化地图右上角信息控件
    initInfoControl() {
      this.info_control = L.control()
      this.info_control.onAdd = function(map) {
        this._div = L.DomUtil.create('div', 'map-info'); // create a div with a class "info"
        this.update();
        return this._div;
      }
      this.info_control.update = function(props) {
        let name = props? props.name : "中华人民共和国"
        this._div.innerHTML = '<h4>China</h4>' + 
          '<b>' + name +'</b><br />'
      }
    },
    // 地图相关事件
    onEachFeature(feature, layer) {
      layer.on({
        mouseover: this.highlightFeature,
        mouseout: this.resetHighlight,
        click: this.zoomToFeature
      })
    },
    // 地图触碰高亮，在onEachFeature中调用
    highlightFeature(e) {
      var layer = e.target
      
      layer.setStyle({
        weight: 3,
        color: '#fff',
        dashArray: '',
        fillOpacity: 0.7
      })
      if(!L.Browser.ie && !L.Browser.opera && !L.Browser.edge){
        layer.bringToFront()
      }

      this.info_control.update(layer.feature.properties)
    },
    // 地图移除高亮，在onEachFeature中调用
    resetHighlight(e) {
      this.geo_layer.resetStyle(e.target);
      this.info_control.update()
    },
    // 地图点击放大板块，在onEachFeature中调用
    zoomToFeature(e) {
      this.map.fitBounds(e.target.getBounds())
    },
  },
  mounted() {
    this.getDataFormat()
    this.leafletMap()
  }

}



// WEBPACK FOOTER //
// ./src/insurance_esg/js/insurance_esg_map.js